import { Box, TableRow } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { JobStatus, TableList } from "@/atoms";
import { ReviewCards } from "@/components";
import { tableHeadCellsData } from "@/data";
import { StyledTableCell } from "@/styles";

export default function BulkUpdateResults({ data }) {
    const { t } = useTranslation();
    return (
        <Box>
            {data?.status !== "completed" ? (
                <Box
                    shadow={1}
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        p: 3,
                    }}
                >
                    <JobStatus data={data} />
                </Box>
            ) : (
                <>
                    <ReviewCards
                        failedNumber={data?.result?.failedRowsNumber}
                        successNumber={data?.result?.successRowsNumber}
                    />

                    <TableList headCells={tableHeadCellsData.bulkUpdate} isPaginated={false}>
                        {data?.result?.errors?.map(({ col, error, row }) => (
                            <TableRow key={row} role="checkbox" tabIndex={-1} aria-checked hover>
                                <StyledTableCell boldCell={+true}>
                                    {col} {row}
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Box
                                        sx={{
                                            bgcolor: "error.main",
                                            borderRadius: 1,
                                            color: "common.white",
                                            p: 1,
                                            width: "fit-content",
                                        }}
                                    >
                                        {t("labels.failed")}
                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell maxWidth="320px !important">
                                    <Box
                                        wordBreak="break-word"
                                        sx={{
                                            whiteSpace: "pre-wrap",
                                        }}
                                    >
                                        {error}
                                    </Box>
                                </StyledTableCell>
                            </TableRow>
                        ))}
                    </TableList>
                </>
            )}
        </Box>
    );
}

BulkUpdateResults.propTypes = {
    data: PropTypes.array,
};
